<template>
  <section id="localizacao">
    <div class="center-container">
      <div class="title">
        <h2>Localização</h2>
        <div class="decoration">
          <div class="dotted-border"></div>
          <i class="fab fa-pagelines"></i>
          <div class="dotted-border"></div>
        </div>
      </div>
      <div class="content">
        <p class="text-center">Rodovia João Hermenegildo de Oliveira, Km 8.5 - Bragança Paulista - SP</p>
        <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14697.708981561056!2d-46.5004412!3d-22.9344873!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x555fd1074434403e!2sPousada%20Recanto%20da%20Fam%C3%ADlia!5e0!3m2!1spt-BR!2sbr!4v1574052454047!5m2!1spt-BR!2sbr" width="800" height="600" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Location'
}
</script>
